import { Location } from 'react-router-dom';
import DeclarationTabKeys from 'views/declarations/utils/DeclarationTabKeys';

export const getDeclarationActiveTabKey = (location: Location, isManifests: boolean): DeclarationTabKeys => {
    const declarationPathPart = isManifests ? 5 : 3;

    const activeTabKeyFromLocationState = (location.state as { activeTabKey?: DeclarationTabKeys })?.activeTabKey;

    if (activeTabKeyFromLocationState) {
        return activeTabKeyFromLocationState;
    }

    const paths = location.pathname.split('/');
    const activeTabKeyFromLocationPathname = paths[declarationPathPart];

    // Anything that is not a declaration tab of its own (products, master items, house consignments)
    // is a route inside the form tab, so it must not deselect it.
    const isDeclarationTabKey = (Object.values(DeclarationTabKeys) as string[]).includes(
        activeTabKeyFromLocationPathname
    );

    if (!isDeclarationTabKey) {
        return DeclarationTabKeys.FORM;
    }

    return activeTabKeyFromLocationPathname as DeclarationTabKeys;
};
